module.exports = __webpack_public_path__ + "40f56f5a736da4effeb790cedb8a52f0.svg";